<div class="flex flex-col gap-10 animate-fadeIn p-6 w-full">
  <div class="grid grid-cols-1 lg:grid-cols-2 gap-x-20 gap-y-12">
    
    <!-- Left Column: Token Configuration -->
    <div class="flex flex-col gap-8">
      <div class="flex flex-col gap-1">
        <h3 class="text-xl font-bold text-slate-700 tracking-tight">{{ 'novigest_title' | translate }}</h3>
        <p class="text-sm text-slate-400 font-medium">{{ 'novigest_desc' | translate }}</p>
      </div>

      <div class="flex flex-col gap-5">
        <!-- Token Input Field -->
        <div class="flex flex-col gap-2">
          <label class="text-sm font-semibold text-slate-500">
            {{ 'novigest_token_label' | translate }}<span class="text-rose-500 ml-0.5">*</span>
          </label>
          <p-password
            [(ngModel)]="novigestToken"
            [toggleMask]="true"
            [feedback]="false"
            [placeholder]="'novigest_token_placeholder' | translate"
            styleClass="w-full"
            inputStyleClass="!w-full !rounded-xl !border-slate-200 !pl-4 !pr-11 !py-3 !text-sm focus:!border-primary transition-all shadow-none h-[48px]"></p-password>
        </div>
      </div>

      <!-- Action Button -->
      <div class="flex justify-start pt-4 w-full" *hasPermission="'Configurações:edit'">
        <app-button
          [label]="'common_save' | translate"
          [loading]="isSaving()"
          [disabled]="isSaving() || !novigestToken() || novigestToken().trim() === ''"
          (onClick)="onSave()"
          icon="pi pi-save"
          styleClass="min-w-[180px]">
        </app-button>
      </div>

      <!-- Auto Sync Toggle -->
      <div class="flex items-center justify-between gap-4 pt-4 border-t border-slate-100">
        <div class="flex flex-col gap-1">
          <label class="text-sm font-semibold text-slate-500">{{ 'novigest_auto_sync_label' | translate }}</label>
          <p class="text-xs text-slate-400">
            {{ (hasSavedToken() ? 'novigest_auto_sync_desc' : 'novigest_auto_sync_disabled_hint') | translate }}
          </p>
        </div>
        <p-toggleswitch
          [(ngModel)]="autoSync"
          [disabled]="!hasSavedToken() || isSavingAutoSync() || !canEdit"
          (onChange)="onAutoSyncChange($event.checked)">
        </p-toggleswitch>
      </div>
    </div>

    <!-- Right Column: Historic Data Import -->
    <div class="flex flex-col gap-8 border-t lg:border-t-0 lg:border-l border-slate-100 lg:pl-16 pt-8 lg:pt-0">
      <div class="flex flex-col gap-1">
        <h3 class="text-xl font-bold text-slate-700 tracking-tight">{{ 'novigest_import_title' | translate }}</h3>
        <p class="text-sm text-slate-400 font-medium">{{ 'novigest_import_subtitle' | translate }}</p>
      </div>

      <!-- Import Button — always enabled so users can start the wizard regardless of token -->
      <div class="pt-4" *hasPermission="'Configurações:create'">
        <app-button
          [label]="'novigest_import_button' | translate"
          [disabled]="!hasSavedToken()"
          (onClick)="onImportHistoricData()"
          icon="pi pi-cloud-download"
          variant="secondary"
          styleClass="min-w-[220px]">
        </app-button>
      </div>
    </div>
    
  </div>
</div>
